import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { CcRequirement, CcRequirementParentChild } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    CcRequirementObjectProps,
    RequirementFilters,

    SortCcRequirement,
    CreateManyCcRequirementParentChild,
    LoadAllCcRequirementParentChild,
    LoadCcRequirementChildren,

    setNotAssignedCcRequirementIds,
    setNotAssignedCcRequirementSort,
    setNotAssignedCcRequirementFilters,
    setNotAssignedCcRequirementSelected,
    setCcRequirementParentChild,
    setAssignedCcRequirementChildren,
    closeModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    SpinnerIcon,
} from "client/components"

import CcRequirementSearch from "client/pages/search/ccRequirementSearch"
import Columns from "./columns"

let isMounted: boolean

const NotAssignedChildren = ({
    requirement,
}: CcRequirementObjectProps) => {
    const requirementList = useSelector((state: StoreType) => state.ccRequirement.requirementList)
    const assignedChildren = useSelector((state: StoreType) => state.ccRequirement.assigned.children)

    const requirementIds = useSelector((state: StoreType) => state.ccRequirement.notAssigned.requirementIds)
    const sortColumn = useSelector((state: StoreType) => state.ccRequirement.notAssigned.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.ccRequirement.notAssigned.sortOrder)
    const filters = useSelector((state: StoreType) => state.ccRequirement.notAssigned.filters)
    const selected = useSelector((state: StoreType) => state.ccRequirement.notAssigned.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        dispatch(setNotAssignedCcRequirementFilters({}))
        dispatch(setNotAssignedCcRequirementSelected([]))

        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedRequirements = SortCcRequirement(Object.values(requirementList), sortColumn, sortOrder, filters)
        const assignedIds = assignedChildren[requirement.id] || []

        const sortedIds: number[] = []
        sortedRequirements.forEach((row) => {
            if (!assignedIds.includes(row.id) && row.id !== requirement.id) sortedIds.push(row.id)
        })
        dispatch(setNotAssignedCcRequirementIds(sortedIds))
    }, [requirementList, assignedChildren, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof CcRequirement, order) => {
        dispatch(setNotAssignedCcRequirementSort(column, order))
    }

    const onFilter = (newFilters: RequirementFilters) => {
        dispatch(setNotAssignedCcRequirementFilters(newFilters))
        dispatch(setNotAssignedCcRequirementSelected([]))
    }

    const addChildren = () => {
        setSaveState(PENDING)

        const data: CcRequirementParentChild[] = []
        selected.forEach((id) => {
            data.push({
                parentId: requirement.id,
                childId: id,
                projectId: requirement.projectId,
            })
        })

        CreateManyCcRequirementParentChild(data).then(() => {
            Promise.all([
                LoadAllCcRequirementParentChild(requirement.projectId).then((res) => {
                    dispatch(setCcRequirementParentChild(res))
                }),
                LoadCcRequirementChildren(requirement.id).then((res) => {
                    dispatch(setAssignedCcRequirementChildren(requirement.id, res))
                }),
            ]).then(() => {
                if (isMounted) {
                    setSaveState(IDLE)
                    dispatch(closeModal())
                }
            })
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectRequirement_s}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <CcRequirementSearch
                        id="notAssignedChildren"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={requirementList}
                    dataIds={requirementIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                />
                <PageForm>
                    <Button variant="success" onClick={addChildren}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default NotAssignedChildren
